<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Test Anagrafica Regionale" header-tag="header" footer-tag="footer" title="">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Struttura</label>
                        <b-form-select id="inline-form-custom-select-pref" v-model="struttura" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="codiciStruttureOptions"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                        <label class="sa-label-data">Idnetificativo</label>
                        <b-form-input v-model="identificativo"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="sa-padding-right text-right" style="padding-top: 10px">
                        <b-button type="reset" v-on:click="onReset" variant="outline-danger">Reset</b-button>
                        <b-button type="submit" variant="outline-info">Esegui Test</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-card>
        <b-card class="sa-card" header="Risposta" header-tag="header" footer-tag="footer" title="">
            <div style="flex: 1; background-color: rgb(247, 247, 247); border: 1px solid #b5b3b3; padding: 5px; border-radius: 5px">
                <pre>{{ formattedJsonData }}</pre>
            </div>
        </b-card>
    </div>
</template>
<script>
// import axios from "axios";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../utility/UtilityMixin";
// import FlussiDettagliModalViewComponent from "./FlussiDettagliModalViewComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: {},
    data() {
        return {
            pathResource: "/anagraficaregionale/assistibileunificato/",
            struttura: null,
            identificativo: null,
            jsonData: {},
            codiciStruttureOptions: [
                { value: null, text: "-Seleziona Valore-" },
                { value: "180000", text: "180000" },
                { value: "012000", text: "012000" },
                { value: "150206", text: "150206" },
            ],
        };
    },
    computed: {
        formattedJsonData() {
            if (!this.jsonData || Object.keys(this.jsonData).length === 0) {
                return "";
            }
            try {
                return JSON.stringify(this.jsonData, null, 2);
            } catch (error) {
                return "Errore nella formattazione del JSON";
            }
        },
    },
    methods: {
        onSubmit() {
            let me = this;
            if (me.identificativo !== null && me.identificativo !== "") {
                if (me.struttura !== null && me.struttura !== "") {
                    let path = me.pathResource + me.struttura + "?identificativo=" + me.identificativo.toUpperCase();
                    UtilityMixin.methods.loadDataResources(path, null, me.loadDataSuccess, me.loadDataError);
                } else {
                    me.jsonData = { esito: false, returnValue: 0, messaggio: "Campo Struttura non valido", data: "" };
                }
            } else {
                me.jsonData = { esito: false, returnValue: 0, messaggio: "Campo Identificativo non valido", data: "" };
            }
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data;
            me.$emit("afterLoadData");
            me.listKey++;
        },
        loadDataError(response) {
            let me = this;
            console.log(response);

            me.jsonData = response.response.data;
        },
        onReset() {
            let me = this;
            me.identificativo = null;
            me.struttura = null;
            me.jsonData = {};
        },
    },
};
</script>
